document.addEventListener('DOMContentLoaded', () => {
    const anchorLinks = document.querySelectorAll('a[href^="#"]');

    anchorLinks.forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();

            const targetId = this.getAttribute('href').substring(1);
            const targetElement = document.getElementById(targetId);
            const header = document.querySelector('#shopify-section-header'); // Get the header element
            const headerHeight = header ? header.offsetHeight : 0; // Get header height

            if (targetElement) {
                window.scrollTo({
                    top: targetElement.offsetTop - headerHeight, // Apply offset
                    behavior: 'smooth'
                });
            }
        });
    });
});
